import logger from "@airhelp/node-logger";
import type { LanguageCode } from "config/languages";
import { useServerSideStoryblokPages } from "contexts/DataContext/hooks";
import { getParentLanguage } from "utils/localeUtils";
import { storyblokPages } from "./config";
import type { PageName } from "./types";

const getStoryblokPageUrl = (language: LanguageCode, pageName: PageName): string => {
  const pageId = storyblokPages[pageName];
  const pages = useServerSideStoryblokPages();

  const page = pages[pageId];
  const parentLanguage = getParentLanguage(language);

  const { [language]: languageUrl, [parentLanguage]: parentLanguageUrl, en: englishUrl } = page;

  if (languageUrl) return `${languageUrl}/`;
  if (parentLanguageUrl) return `${parentLanguageUrl}/`;
  logger.warn(`Url for ${pageName} in "${language}" was not found.`);

  if (englishUrl) return `${englishUrl}/`;

  logger.error(`Url for ${pageName} in was not found.`);

  return "/";
};

export default getStoryblokPageUrl;
